module.exports = __webpack_public_path__ + "img/09.f7bb10a5.svg";